import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import { FastField, Field, Formik } from 'formik';
import { AnimatePresence, motion } from 'framer-motion';
import { AppDialogHelper } from 'general/components/AppDialog';
import AppTabs from 'general/components/AppTabs';
import KTImageInput from 'general/components/OtherKeenComponents/FileUpload/KTImageInput';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown, {
  KTBSDropdownDirections,
} from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTSwitch, {
  KTSwitchType,
} from 'general/components/OtherKeenComponents/KTFormControls/KTSwitch';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

ChargePointAddView.propTypes = {
  chargeStationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  chargePointId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function ChargePointAddView(props) {
  // MARK: ---- PROPERTIES ----
  const MAX_CONNECTORS = 2;
  const [readyToValidate, setReadyToValidate] = useState(false);
  const { chargeStationId, chargePointId } = props;
  const editMode = !!chargePointId;
  const [chargePointDetail, setChargePointDetail] = useState();
  useEffect(() => {
    if (chargePointId) {
      ChargeHelper.API.requestGetChargePointDetail(chargePointId).then((chargePoint) => {
        setChargePointDetail(chargePoint);
      });
    }
  }, [chargePointId]);
  const [chargeStationDetail, setChargeStationDetail] = useState();
  useEffect(() => {
    const stationId = chargeStationId ?? chargePointDetail?.stationId;
    if (stationId) {
      ChargeHelper.API.getChargeStationDetail(stationId).then((chargeStation) => {
        setChargeStationDetail(chargeStation);
      });
    }
  }, [chargeStationId, chargePointDetail]);
  const [selectedChargeStation, setSelectedChargeStation] = useState(null);
  useEffect(() => {
    setSelectedChargeStation({
      id: chargeStationDetail?.stationId,
      name: chargeStationDetail?.name,
      item: chargeStationDetail,
      address: ChargeHelper.Utils.getChargeStationFullAddress(chargeStationDetail)
    });
  }, [chargeStationDetail])
  const router = useRouter();
  const refFooter = useRef();
  const [loading, setLoading] = useState(false);
  const footer = KTUtil.getById('kt_footer');
  const footerHeight = footer?.offsetHeight ?? 0;
  const user = useSelector((state) => state.auth.user);
  const refFormik = useRef(null);
  const initialFormikValues = useMemo(() => {
    return {
      stationId: chargeStationId,
      areaId: chargeStationDetail?.areaId,
      power: chargePointDetail?.chargeModel?.power ?? 0,
      vendor: chargePointDetail?.vendor,
      type: chargePointDetail?.type ?? ChargeConstants.ChargePointType.AC,
      pointCode: chargePointDetail?.pointCode ?? '',
      name: chargePointDetail?.name ?? '',
      serialNumber: chargePointDetail?.serialNumber ?? '',
      modelId: chargePointDetail?.modelId,
      model: chargePointDetail?.model,
      operatorId: chargeStationDetail?.operatorId,
      firmwareVersion: chargePointDetail?.firmwareVersion ?? '',
      iccid: chargePointDetail?.iccid ?? '',
      phoneNumber: chargePointDetail?.phoneNumber ?? '',
      networkOperator: chargePointDetail?.networkOperator ?? ChargeConstants.networkOperator.VIETTEL,
      dataPackage: chargePointDetail?.dataPackage ?? '',
      dataPackageExpire: chargePointDetail?.dataPackageExpire ?? null,
      numberConnectors: chargePointDetail?.numberConnectors ?? 1,
      voltage: chargePointDetail?.chargeModel?.voltage ?? 0,
      maxAmpere: 0,
      protocol: 'OCPP1.6',
      connected: chargePointDetail?.connected ?? 1,
      ipAddress: chargePointDetail?.ipAddress ?? '',
      ocppId: chargePointDetail?.ocppId ?? '',
      ocppPassword: chargePointDetail?.ocppPassword ?? 'tmt12345',
      status: chargePointDetail?.status ?? ChargeConstants.ChargePointStatus.DISCONNECTED,
      image: chargePointDetail?.image ?? null,
      vehicleType: chargePointDetail?.chargeModel?.VehicleType ?? ChargeConstants.VehicleType.CAR,
      ocppDebug: chargePointDetail ? chargePointDetail?.ocppDebug : 1,
      // pricing
      pricingMode:
        chargePointDetail?.pricing?.pricingMode ?? ChargeConstants.ChargePricingMode.FLAT,
      flatPrice: chargePointDetail?.pricing?.flatPrice ?? 0,
      normalPrice: chargePointDetail?.pricing?.normalPrice ?? 0,
      peakPrice: chargePointDetail?.pricing?.peakPrice ?? 0,
      offPeakPrice: chargePointDetail?.pricing?.offPeakPrice ?? 0,
      freeOverchargeDuration: chargePointDetail?.pricing?.freeOverchargeDuration
        ? chargePointDetail?.pricing?.freeOverchargeDuration / 60
        : 0,
      reservationFee: chargePointDetail?.pricing?.reservationFee
        ? chargePointDetail?.pricing?.reservationFee
        : 0,
      overchargePrice: chargePointDetail?.pricing?.overchargePrice ?? 0,
      currency: 'VNĐ',
    };
  }, [chargeStationDetail, chargePointDetail]);
  const validationSchema = useMemo(
    () => ChargeHelper.ValidationSchema.getChargePointValidationSchema(editMode),
    [editMode]
  );
  const [imageSrc, setImageSrc] = useState(null);
  const tabs = useMemo(() => {
    return ['Thông tin trụ sạc', 'Giá sạc điện'].reverse();
  }, []);
  const [selectedTab, setSelectedTab] = useState(tabs[1]);
  const [chargeBrandList, setChargeBrandList] = useState([]);
  const [selectedChargeBrand, setSelectedChargeBrand] = useState();
  const [chargeModelList, setChargeModelList] = useState([]);
  const [selectedChargeModel, setSelectedChargeModel] = useState();
  useEffect(() => {
    ChargeHelper.API.requestGetChargeBrandList().then((response) => {
      setChargeBrandList(response.brands);
    });
  }, [chargePointId]);
  const chargeBrandOptions = useMemo(() => {
    return chargeBrandList.map((brand) => ({
      value: brand.brandId,
      name: brand.name,
    }));
  }, [chargeBrandList]);
  useEffect(() => {
    if (selectedChargeBrand) {
      ChargeHelper.API.requestGetChargeModelList({ brandId: selectedChargeBrand?.brandId }).then(
        (response) => {
          setChargeModelList(response.models);
        }
      );
    }
  }, [selectedChargeBrand]);
  const chargeModelOptions = useMemo(() => {
    return chargeModelList.map((model) => ({
      value: model.modelId,
      name: model.name,
    }));
  }, [chargeModelList]);
  useEffect(() => {
    if (chargePointDetail) {
      setSelectedChargeModel(chargePointDetail?.chargeModel);
      setSelectedChargeBrand(
        _.find(chargeBrandList, (item) => item?.brandId === chargePointDetail?.chargeModel?.brandId)
      );
    }
  }, [chargePointDetail, chargeBrandList]);
  const [chargeConnectorList, setChargeConnectorList] = useState([]);
  useEffect(() => {
    if (!editMode || chargePointDetail?.chargeConnectors?.length === 0) {
      setChargeConnectorList([ChargeConstants.ChargeConnectorType.CCS2]);
    }
  }, [chargePointDetail, editMode]);
  useEffect(() => {
    if (chargePointDetail) {
      const cpConnectorList = chargePointDetail?.chargeConnectors ?? [];
      if (cpConnectorList.length > 0) {
        setChargeConnectorList(
          cpConnectorList
            .map((connector) => connector.type)
            .slice(0, MAX_CONNECTORS)
        );
      }
    }
  }, [chargePointDetail, MAX_CONNECTORS]);
  // dinh gia
  const [pricingOn, setPricingOn] = useState(false);
  useEffect(() => {
    setPricingOn(
      !!chargePointDetail?.pricing &&
      chargePointDetail?.pricing?.pointId === chargePointDetail?.pointId
    );
  }, [chargePointDetail]);

  useEffect(() => {
    if (Utils.isValid(selectedChargeModel) && Utils.isValid(refFormik.current)) {
      refFormik.current.setFieldValue('modelId', selectedChargeModel?.modelId);
      refFormik.current.setFieldValue('voltage', selectedChargeModel?.voltage);
      refFormik.current.setFieldValue('power', selectedChargeModel?.power);
      refFormik.current.setFieldValue(
        'vehicleType',
        selectedChargeModel?.vehicleType ?? ChargeConstants.VehicleType.CAR
      );
      refFormik.current.setFieldValue('type', selectedChargeModel?.type);
    }
  }, [selectedChargeModel, refFormik]);
  const chargePointNumberConnectorOptions = useMemo(() => {
    const vehicleType = selectedChargeModel?.vehicleType ?? ChargeConstants.VehicleType.CAR;
    if (vehicleType === ChargeConstants.VehicleType.CAR) {
      return ChargeHelper.Data.chargePointNumberConnectorOptions.filter(
        (item) => item.value <= MAX_CONNECTORS
      );
    } else {
      return ChargeHelper.Data.chargePointNumberConnectorOptions.filter(
        (item) => item.value <= MAX_CONNECTORS
      );
    }
  }, [ChargeHelper.Data.chargePointNumberConnectorOptions, selectedChargeModel, MAX_CONNECTORS]);
  useEffect(() => {
    const vehicleType = selectedChargeModel?.vehicleType ?? ChargeConstants.VehicleType.CAR;
    if (vehicleType === ChargeConstants.VehicleType.CAR || vehicleType === ChargeConstants.VehicleType.BIKE) {
      if (chargeConnectorList.length > MAX_CONNECTORS) {
        setChargeConnectorList(chargeConnectorList.slice(0, MAX_CONNECTORS));
      }
    }
  }, [selectedChargeModel, chargeConnectorList, MAX_CONNECTORS]);

  // MARK: ---- METHODS ----
  const handleSelectedTab = (newTab) => {
    if (selectedTab === newTab) return;
    setSelectedTab(newTab);
  };
  const handleSubmit = async (values) => {
    console.log('values: ', values);
    if (pricingOn) {
      if (!Utils.isValid(values.overchargePrice) || !Utils.isValid(values.freeOverchargeDuration || !Utils.isValid(values.reservationFee))) {
        ToastHelper.showError('Vui lòng nhập đầy đủ thông tin giá điện');
        setSelectedTab(tabs[0]);
        return;
      }
      if (values.pricingMode === ChargeConstants.ChargePricingMode.FLAT) {
        if (!Utils.isValid(values.flatPrice)) {
          ToastHelper.showError('Vui lòng nhập đầy đủ thông tin giá điện');
          setSelectedTab(tabs[0]);
          return;
        }
      } else if (values.pricingMode === ChargeConstants.ChargePricingMode.HOURS) {
        if (
          !Utils.isValid(values.normalPrice) ||
          !Utils.isValid(values.peakPrice) ||
          !Utils.isValid(values.offPeakPrice)
        ) {
          ToastHelper.showError('Vui lòng nhập đầy đủ thông tin giá điện');
          setSelectedTab(tabs[0]);
          return;
        }
      }
    }

    let param = { ...values };

    param.stationId = selectedChargeStation?.id;
    // param = _.omitBy(param, _.isNil);
    if (imageSrc) {
      const res = await miscHelper.callApiUploadFile(imageSrc);
      if (_.isArray(res) && res.length > 0) {
        param.image = res[0].relativePath;
      }
    }
    console.log({ param });
    param.numberConnectors = chargeConnectorList.length;
    // return;
    setLoading(true);
    try {
      let res = null;
      if (!editMode) {
        const response = await ChargeHelper.API.requestAddChargePoint(param);
        if (_.isString(response)) {
          ToastHelper.showError(response);
          return;
        }
        const { result, reason, chargePoint } = response;
        if (result === 'success') {
          // them tru sac thanh cong
          const cpId = chargePoint?.pointId;
          if (cpId) {
            // them voi sac
            chargeConnectorList.forEach(async (connector, index) => {
              const createChargeConnectorParam = {
                connectorNumber: index + 1,
                type: connector,
                status: ChargeConstants.ChargeConnectorStatus.AVAILABLE,
              };
              await ChargeHelper.API.requestCreateChargeConnector(cpId, createChargeConnectorParam);
            });

            // them dinh gia dien
            if (pricingOn) {
              const pricingParam = {
                pointId: cpId,
                pricingMode: values.pricingMode,
                freeOverchargeDuration: values.freeOverchargeDuration * 60,
                overchargePrice: values.overchargePrice,
                reservationFee: values.reservationFee,
                currency: values.currency,
              };
              if (values.pricingMode === ChargeConstants.ChargePricingMode.FLAT) {
                pricingParam.flatPrice = values.flatPrice;
              } else if (values.pricingMode === ChargeConstants.ChargePricingMode.HOURS) {
                pricingParam.normalPrice = values.normalPrice;
                pricingParam.peakPrice = values.peakPrice;
                pricingParam.offPeakPrice = values.offPeakPrice;
              }
              await ChargeHelper.API.requestCreateChargePricing(pricingParam);
            }
          }

          ToastHelper.showSuccess('Thêm trụ sạc thành công');
          router.navigate(-1);
        } else {
          ToastHelper.showError(reason);
        }
      } else {
        const result = await ChargeHelper.API.requestUpdateChargePoint(chargePointId, param);
        if (result?.success) {
          // cap nhat voi sac
          chargeConnectorList.forEach(async (connector, index) => {
            if (index >= chargePointDetail?.chargeConnectors?.length) {
              const createChargeConnectorParam = {
                connectorNumber: index + 1,
                type: connector,
                status: ChargeConstants.ChargeConnectorStatus.AVAILABLE,
              };
              await ChargeHelper.API.requestCreateChargeConnector(
                chargePointId,
                createChargeConnectorParam
              );
            } else {
              const connectorId = _.find(
                chargePointDetail?.chargeConnectors,
                (item) => item.connectorNumber === index + 1
              )?.connectorId;
              if (Utils.isValid(connectorId)) {
                const updateChargeConnectorParam = {
                  connectorNumber: index + 1,
                  type: connector,
                  status: ChargeConstants.ChargeConnectorStatus.AVAILABLE,
                };
                await ChargeHelper.API.requestUpdateChargeConnector(
                  chargePointId,
                  connectorId,
                  updateChargeConnectorParam
                );
              }
            }
          });
          if (chargePointDetail?.chargeConnectors?.length > chargeConnectorList.length) {
            const deleteChargeConnectorIds = chargePointDetail?.chargeConnectors
              ?.slice(chargeConnectorList.length)
              ?.map((item) => item.connectorId);
            console.log(chargeConnectorList, deleteChargeConnectorIds);

            deleteChargeConnectorIds.forEach(async (connectorId) => {
              await ChargeHelper.API.requestDeleteChargeConnector(chargePointId, connectorId);
            });
          }

          // cap nhat dinh gia dien
          if (pricingOn) {
            const pricingParam = {
              pointId: chargePointId,
              pricingMode: values.pricingMode,
              freeOverchargeDuration: values.freeOverchargeDuration * 60,
              overchargePrice: values.overchargePrice,
              reservationFee: values.reservationFee,
              currency: values.currency,
            };
            if (values.pricingMode === ChargeConstants.ChargePricingMode.FLAT) {
              pricingParam.flatPrice = values.flatPrice;
            } else if (values.pricingMode === ChargeConstants.ChargePricingMode.HOURS) {
              pricingParam.normalPrice = values.normalPrice;
              pricingParam.peakPrice = values.peakPrice;
              pricingParam.offPeakPrice = values.offPeakPrice;
            }
            // QUYBKA: ---- Sua loi xoa dinh gia dien khi cap nhat ----
            if (chargePointDetail?.pricing?.pointId === chargePointDetail?.pointId) {
              await ChargeHelper.API.requestUpdateChargePricing(
                chargePointDetail?.pricing?.pricingId,
                pricingParam
              );
            } else {
              await ChargeHelper.API.requestCreateChargePricing(pricingParam);
            }
          } else {
            // QUYBKA: ---- Sua loi xoa dinh gia dien khi cap nhat ----
            if (chargePointDetail?.pricing?.pointId === chargePointDetail?.pointId) {
              await ChargeHelper.API.requestDeleteChargePricing(
                chargePointDetail?.pricing?.pricingId
              );
            }
          }
          // cap nhat tru sac thanh cong
          ToastHelper.showSuccess('Cập nhật trụ sạc thành công');
          router.navigate(-1);
        } else {
          const errorMessage = result?.reason || 'Cập nhật trụ sạc thất bại';
          ToastHelper.showError(errorMessage);
          setSelectedTab(tabs[1]);
        }
      }
    } catch (error) {
      ToastHelper.showError(error);
    } finally {
      setLoading(false);
    }
  };
  const [isOcppNull, setOcppNull] = useState(true);
  useEffect(() => {
    if (chargePointDetail && chargePointDetail?.ocppId) {
      setOcppNull(false);
    }
  }, [chargePointDetail])

  const dropdownChargeStationEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="stationId"
        name="stationId"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between 
              ${readyToValidate && !Utils.isValid(selectedChargeStation) ? 'button-invalid' : ''}
              ${!editMode ? 'dropdown-disabled' : ''}
              `}
            type="button"
          >
            {selectedChargeStation?.name ?? 'Chọn trạm sạc'}
          </button>
        }
        selectedValue={selectedChargeStation}
        subTitleType="address"
        dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
        getSubItems={async (item) => {
          return ChargeHelper.API.requestGetChargeStationList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.chargeStations?.map((station) => ({
                id: station?.stationId,
                name: station?.name,
                item: station,
                address: ChargeHelper.Utils.getChargeStationFullAddress(station),
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          ChargeHelper.UI.showDialogConfirmChangeChargeStation(value, (isConfirmed) => {
            if (isConfirmed) {
              setSelectedChargeStation(value);
            }
          });
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'Trạm sạc',
          role: 'STATION',
        }}
        disabled={!editMode}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedChargeStation(null);
            })}
          </div>
        }
      />
    )
  }, [selectedChargeStation, readyToValidate, editMode])

  return (
    <div>
      <Formik
        initialValues={initialFormikValues}
        validationSchema={validationSchema}
        enableReinitialize={true}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {(formikProps) => {
          refFormik.current = formikProps;
          return (
            <div>
              <div
                className="px-4 mb-4 mt-1"
                style={{
                  paddingBottom: `calc(${refFooter.current?.offsetHeight ?? 0
                    }px - ${footerHeight}px)`,
                }}
              >
                      <AppTabs tabs={tabs} activeTab={selectedTab} handleClick={handleSelectedTab} />
                <AnimatePresence mode="wait">
                  <motion.div
                    key={selectedTab}
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -10, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    {UIHelper.buildCard(
                      <div>
                        {/* {UIHelper.buildCardHeader(!editMode ? 'Thêm trụ sạc' : 'Sửa trụ sạc', true, null, true)} */}
                        {/* content */}
                        <div>
                          {selectedTab === tabs[1] ? (
                            <div className="pt-4">
                              {/* thong tin tru sac */}
                              <div
                                style={{
                                  borderBottom: `1px dashed ${AppColors.gray[300]}`,
                                }}
                              >
                                <div className="row m-0 p-0 px-2">
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div className="w-120px">
                                      {UIHelper.buildFormLabel('Ảnh trụ sạc')}
                                      <FastField name="image">
                                        {({ field, form, meta }) => (
                                          <KTImageInput
                                            fullWidth={true}
                                            aspectRatio={'1'}
                                            name={field.name}
                                            editable={true}
                                            value={
                                              Utils.isValid(field.value)
                                                ? Utils.getFullUrl(field.value)
                                                : null
                                            }
                                            acceptImageTypes={['image/png', 'image/jpg', 'image/jpeg']}
                                            defaultImage={
                                              AppResource.images.chargeConnectorTypes
                                                .imgChargePointDefault
                                            }
                                            enableCheckValid
                                            onSelectedFile={(file) => {
                                              setImageSrc(file);
                                              const imageUrl = URL.createObjectURL(file);
                                              form.setFieldValue(field.name, imageUrl);
                                            }}
                                            onRemovedFile={() => {
                                              setImageSrc(null);
                                              form.setFieldValue(field.name, null);
                                            }}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                          />
                                        )}
                                      </FastField>
                                    </div>
                                    {UIHelper.buildFormText('Định dạng: JPG, PNG, JPEG')}
                                  </div>
                                  <div className="col-lg-4 mb-4 px-2">
                                    {/* hang sx tru sac */}
                                    <div>
                                      {UIHelper.buildFormLabel('Hãng sản xuất trụ sạc', true)}
                                      <KTBSDropdown
                                        name="chargeBrandId"
                                        toggleElement={
                                          <button
                                            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${readyToValidate && !Utils.isValid(selectedChargeBrand)
                                              ? 'button-invalid'
                                              : ''
                                              }`}
                                            type="button"
                                          >
                                            {selectedChargeBrand
                                              ? selectedChargeBrand?.name
                                              : 'Chọn hãng sản xuất trụ sạc'}
                                          </button>
                                        }
                                        selectedValue={selectedChargeBrand?.brandId}
                                        dropdownMenuItems={chargeBrandOptions}
                                        dropdownMenuClassName="overflow-auto w-100"
                                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                                        onChange={(value) => {
                                          setSelectedChargeModel(null);
                                          formikProps.setFieldValue('modelId', '');
                                          setSelectedChargeBrand(
                                            _.find(
                                              chargeBrandList,
                                              (item) => item.brandId === value
                                            )
                                          );
                                        }}
                                        isDropdownForm={true}
                                      />
                                    </div>

                                    {/* so serial */}
                                    <div className="mt-4">
                                      {UIHelper.buildFormLabel('Số serial', true)}
                                      <Field name="serialNumber">
                                        {({ field, form, meta }) => (
                                          <KTFormInput
                                            type={KTFormInputType.text}
                                            placeholder="Nhập số serial"
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                              // Số serial tương ứng với mã CPID (ocppId) khi ocppId đang trống
                                              if (isOcppNull) {
                                                if (value) {
                                                  formikProps.setFieldValue('ocppId', value);
                                                } else {
                                                  formikProps.setFieldValue('ocppId', '');
                                                }
                                              }
                                            }}
                                            onBlur={() => {
                                              form.setFieldTouched(field.name, true);
                                            }}
                                            enableCheckValid={true}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                          />
                                        )}
                                      </Field>
                                    </div>
                                  </div>
                                  <div className="col-lg-4 mb-4 px-2">
                                    {/* model tru sac */}
                                    <div>
                                      {UIHelper.buildFormLabel('Dòng trụ sạc', true)}
                                      <Field name="modelId">
                                        {({ field, form, meta }) => (
                                          <KTBSDropdown
                                            name={field.name}
                                            toggleElement={
                                              <button
                                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                                                ${meta.touched && !_.isEmpty(meta.error)
                                                    ? 'button-invalid'
                                                    : ''
                                                  }`}
                                                type="button"
                                              >
                                                {selectedChargeModel
                                                  ? selectedChargeModel?.name
                                                  : 'Chọn dòng trụ sạc'}
                                              </button>
                                            }
                                            selectedValue={field.value}
                                            dropdownMenuItems={chargeModelOptions}
                                            dropdownMenuClassName="overflow-auto w-100"
                                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                                            onChange={(value) => {
                                              const model = _.find(
                                                chargeModelList,
                                                (item) => item.modelId === value
                                              );
                                              setSelectedChargeModel(model);
                                              form.setFieldValue(field.name, _.toString(value));
                                              formikProps.setFieldValue('voltage', model?.voltage);
                                              formikProps.setFieldValue('power', model?.power);
                                              formikProps.setFieldValue(
                                                'vehicleType',
                                                model?.vehicleType ??
                                                ChargeConstants.VehicleType.CAR
                                              );
                                              formikProps.setFieldValue('type', model?.type);
                                            }}
                                            isDropdownForm={true}
                                          />
                                        )}
                                      </Field>
                                    </div>

                                    {/* loai phuong tien */}
                                    {/* <div className="mt-4">
                                      {UIHelper.buildFormLabel('Loại phương tiện', true)}
                                      <FastField name="vehicleType">
                                        {({ field, form, meta }) => (
                                          <KTBSDropdown
                                            name={field.name}
                                            toggleElement={
                                              <button
                                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between disabled`}
                                                type="button"
                                              >
                                                {field.value
                                                  ? _.find(
                                                    ChargeHelper.Data.vehicleTypeOptions,
                                                    (item) => item?.value === field.value
                                                  )?.name
                                                  : 'Chọn loại phương tiện'}
                                              </button>
                                            }
                                            selectedValue={field.value}
                                            dropdownMenuItems={ChargeHelper.Data.vehicleTypeOptions}
                                            dropdownMenuClassName="overflow-auto w-100"
                                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                            }}
                                            isDropdownForm={true}
                                            disabled={true}
                                          />
                                        )}
                                      </FastField>
                                    </div> */}

                                    {/* ma tru sac */}
                                    <div className="mt-4">
                                      {UIHelper.buildFormLabel('Mã trụ sạc', editMode)}
                                      <Field name="pointCode">
                                        {({ field, form, meta }) => (
                                          <KTFormInput
                                            type={KTFormInputType.text}
                                            placeholder="Nhập mã trụ sạc"
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                            }}
                                            onBlur={() => {
                                              form.setFieldTouched(field.name, true);
                                            }}
                                            enableCheckValid={true}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                          />
                                        )}
                                      </Field>
                                    </div>
                                  </div>
                                </div>
                                <div className="row m-0 p-0 px-2">
                                {/* ten tru sac */}
                                <div className="col-lg-4 mb-4 px-2">
                                    {UIHelper.buildFormLabel('Tên trụ sạc', true)}
                                    <Field name="name">
                                      {({ field, form, meta }) => (
                                        <KTFormInput
                                          type={KTFormInputType.text}
                                          placeholder="Nhập tên trụ sạc"
                                          name={field.name}
                                          value={field.value}
                                          title="Vui lòng nhập tên trụ sạc"
                                          onChange={(value) => {
                                            form.setFieldValue(field.name, value);
                                          }}
                                          onBlur={() => {
                                            form.setFieldTouched(field.name, true);
                                          }}
                                          enableCheckValid={true}
                                          isValid={_.isEmpty(meta.error)}
                                          isTouched={meta.touched}
                                          feedbackText={meta.error}
                                        />
                                      )}
                                    </Field>
                                  </div>
                                  {/* cong suat */}
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('Công suất', true)}
                                      <KTFormInput
                                        type={KTFormInputType.currency}
                                        unit="kW"
                                        placeholder="Nhập công suất"
                                        name="power"
                                        value={
                                          selectedChargeModel?.power
                                            ? _.toNumber(selectedChargeModel?.power) / 1000
                                            : 0
                                        }
                                        // onChange={(value) => {
                                        //   form.setFieldValue(field.name, value);
                                        // }}
                                        // onBlur={() => {
                                        //   form.setFieldTouched(field.name, true);
                                        // }}
                                        // enableCheckValid={true}
                                        // isValid={_.isEmpty(meta.error)}
                                        // isTouched={meta.touched}
                                        // feedbackText={meta.error}
                                        disabled={true}
                                      />
                                    </div>
                                  </div>
                                  {/* dien ap */}
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('Điện áp', true)}
                                      <KTFormInput
                                        type={KTFormInputType.currency}
                                        unit="V"
                                        placeholder="Nhập điện áp"
                                        name="voltage"
                                        value={selectedChargeModel?.voltage ?? 0}
                                        // onChange={(value) => {
                                        //   form.setFieldValue(field.name, value);
                                        // }}
                                        // onBlur={() => {
                                        //   form.setFieldTouched(field.name, true);
                                        // }}
                                        // enableCheckValid={true}
                                        // isValid={_.isEmpty(meta.error)}
                                        // isTouched={meta.touched}
                                        // feedbackText={meta.error}
                                        disabled={true}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="row m-0 p-0 px-2">
                                  {/* loai tru */}
                                  <div className="col-lg-6 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('Loại trụ', true)}
                                      <FastField name="type">
                                        {({ field, form, meta }) => (
                                          <KTBSDropdown
                                            name={field.name}
                                            toggleElement={
                                              <button
                                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between disabled`}
                                                type="button"
                                              >
                                                {field.value || 'Chọn loại trụ'}
                                              </button>
                                            }
                                            selectedValue={field.value}
                                            dropdownMenuItems={
                                              ChargeHelper.Data.chargePointTypeOptions
                                            }
                                            dropdownMenuClassName="overflow-auto w-100"
                                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                            }}
                                            isDropdownForm={true}
                                            disabled={true}
                                          />
                                        )}
                                      </FastField>
                                    </div>
                                  </div>
                                  {/* tram sac quan ly */}
                                  <div className="col-lg-6 mb-4 px-2">
                                    <div className='d-flex gap-2'>
                                      {UIHelper.buildFormLabel('Trạm sạc quản lý', true, false)}
                                      <span>
                                        <KTTooltip
                                          text={`<div><span>Bằng việc thay đổi mã trạm sạc, toàn bộ dữ liệu của trụ sạc (bao gồm vị trí, điều hành,...) tại trạm sạc hiện tại sẽ được chuyển tới trạm sạc được lựa chọn.</span></div>`}
                                          textHeader="Trạm sạc quản lý"
                                          isHtmlContent
                                        >
                                          <i
                                            className="fa-regular fa-info-circle"
                                            style={{ color: AppColors.info }}
                                          />
                                        </KTTooltip>
                                      </span>
                                    </div>
                                    {dropdownChargeStationEl}
                                  </div>
                                </div>
                              </div>

                              {/* thong tin ket noi */}
                              <div
                                className=""
                                style={{
                                  borderBottom: `1px dashed ${AppColors.gray[300]}`,
                                }}
                              >
                                {UIHelper.buildCardHeader('Thông tin SIM', false, null, true)}
                                <div className="row m-0 p-0 px-2">
                                  {/* so dien thoai */}
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('Số điện thoại', false)}
                                      <FastField name="phoneNumber">
                                        {({ field, form, meta }) => (
                                          <KTFormInput
                                            type={KTFormInputType.telephone}
                                            placeholder="Nhập số điện thoại"
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                            }}
                                            onBlur={() => {
                                              form.setFieldTouched(field.name, true);
                                            }}
                                            enableCheckValid={false}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                          />
                                        )}
                                      </FastField>
                                    </div>
                                  </div>
                                  {/* so dien thoai */}
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('Số serial SIM', false)}
                                      <FastField name="iccid">
                                        {({ field, form, meta }) => (
                                          <KTFormInput
                                            type={KTFormInputType.telephone}
                                            placeholder="Nhập số serial SIM"
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                            }}
                                            onBlur={() => {
                                              form.setFieldTouched(field.name, true);
                                            }}
                                            enableCheckValid={false}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                          />
                                        )}
                                      </FastField>
                                    </div>
                                  </div>
                                  {/* nha mang */}
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('Nhà mạng', false)}
                                      <FastField name="networkOperator">
                                        {({ field, form, meta }) => (
                                          <KTBSDropdown
                                            name={field.name}
                                            toggleElement={
                                              <button
                                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                                                type="button"
                                              >
                                                {field.value
                                                  ? _.find(
                                                    ChargeHelper.Data.networkOperatorOptions,
                                                    (item) => item?.value === field.value
                                                  )?.name
                                                  : 'Chọn nhà mạng'}
                                              </button>
                                            }
                                            selectedValue={field.value}
                                            dropdownMenuItems={ChargeHelper.Data.networkOperatorOptions}
                                            dropdownMenuClassName="overflow-auto w-100"
                                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                            }}
                                            isDropdownForm={true}
                                          />
                                        )}
                                      </FastField>
                                    </div>
                                  </div>
                                  {/* goi cuoc */}
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('Gói cước', false)}
                                      <FastField name="dataPackage">
                                        {({ field, form, meta }) => (
                                          <KTFormInput
                                            type={KTFormInputType.text}
                                            placeholder="Nhập gói cước"
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                            }}
                                            onBlur={() => {
                                              form.setFieldTouched(field.name, true);
                                            }}
                                            enableCheckValid={false}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                          />
                                        )}
                                      </FastField>
                                    </div>
                                  </div>
                                  {/* hsd goi cuou */}
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('HSD gói cước')}
                                      <FastField name="dataPackageExpire">
                                        {({ field, form, meta }) => (
                                          <KTFormInput
                                            type={KTFormInputType.date}
                                            placeholder={'DD/MM/YYYY'}
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                            }}
                                            onBlur={() => {
                                              form.setFieldTouched(field.name, true);
                                            }}
                                            enableCheckValid={false}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                          />
                                        )}
                                      </FastField>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* thong tin ket noi */}
                              <div
                                className=""
                                style={{
                                  borderBottom: `1px dashed ${AppColors.gray[300]}`,
                                }}
                              >
                                {UIHelper.buildCardHeader('Thông tin kết nối', false, null, true)}
                                <div className="row m-0 p-0 px-2">
                                  {/* ocppId */}
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('Mã CPID', true)}
                                      <FastField name="ocppId">
                                        {({ field, form, meta }) => (
                                          <KTFormInput
                                            type={KTFormInputType.text}
                                            placeholder="Nhập mã CPID"
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                              if (value) {
                                                setOcppNull(false);
                                              } else {
                                                setOcppNull(true);
                                              }
                                            }}
                                            onBlur={() => {
                                              form.setFieldTouched(field.name, true);
                                            }}
                                            enableCheckValid={true}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                          />
                                        )}
                                      </FastField>
                                    </div>
                                  </div>
                                  {/* ocpp password */}
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('Mật khẩu CPID', true)}
                                      <FastField name="ocppPassword">
                                        {({ field, form, meta }) => (
                                          <KTFormInput
                                            type={KTFormInputType.text}
                                            placeholder="Nhập mật khẩu CPID"
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                            }}
                                            onBlur={() => {
                                              form.setFieldTouched(field.name, true);
                                            }}
                                            enableCheckValid={true}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                          />
                                        )}
                                      </FastField>
                                    </div>
                                  </div>
                                  {/* giao thuc */}
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('Giao thức', true)}
                                      <FastField name="protocol">
                                        {({ field, form, meta }) => (
                                          <KTFormInput
                                            type={KTFormInputType.text}
                                            placeholder="Nhập giao thức"
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                            }}
                                            onBlur={() => {
                                              form.setFieldTouched(field.name, true);
                                            }}
                                            enableCheckValid={true}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                            disabled={true}
                                          />
                                        )}
                                      </FastField>
                                    </div>
                                  </div>
                                  {/* ocpp debug */}
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('Chuẩn đoán lỗi CPID', true)}
                                      <FastField name="ocppDebug">
                                        {({ field, form, meta }) => (
                                          <div className="">
                                            <KTSwitch
                                              name={field.name}
                                              checked={field.value}
                                              onChange={(value) => {
                                                form.setFieldValue(field.name, value ? 1 : 0);
                                              }}
                                              type={KTSwitchType.outline}
                                              showIcon={true}
                                              enableCheckValid={true}
                                              isValid={_.isEmpty(meta.error)}
                                              isTouched={meta.touched}
                                              feedbackText={meta.error}
                                            />
                                          </div>
                                        )}
                                      </FastField>
                                      {formikProps.values.ocppDebug == 1 && editMode && (
                                        <span
                                          className="cursor-pointer hover-opacity-60"
                                          style={UIHelper.buildFontStyle(
                                            '500',
                                            '14px',
                                            AppColors.primary
                                          )}
                                          onClick={() => {
                                            Utils.openInNewTab(
                                              ChargeHelper.Utils.getChargePointOCPPDebugLink(
                                                chargePointDetail
                                              )
                                            );
                                          }}
                                        >
                                          {ChargeHelper.Utils.getChargePointOCPPDebugLink(
                                            chargePointDetail
                                          )}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* thong tin voi sac */}
                              <div className="">
                                {UIHelper.buildCardHeader('Thông tin súng sạc', false, null, true)}
                                <div className="row m-0 p-0 px-2">
                                  {/* chon so luong voi sac */}
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('Số lượng súng sạc', true)}
                                      <KTBSDropdown
                                        name="numberConnectors"
                                        direction={KTBSDropdownDirections.up}
                                        toggleElement={
                                          <button
                                            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!Utils.isValid(selectedChargeModel) ? 'disabled' : ''
                                              }`}
                                            type="button"
                                          >
                                            {`${chargeConnectorList.length} súng sạc`}
                                          </button>
                                        }
                                        selectedValue={chargeConnectorList.length}
                                        dropdownMenuItems={chargePointNumberConnectorOptions}
                                        dropdownMenuClassName="overflow-auto w-100"
                                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                                        onChange={(value) => {
                                          const iValue = Math.min(parseInt(value), MAX_CONNECTORS);
                                          formikProps.setFieldValue('numberConnectors', iValue);
                                          const cpConnectorList =
                                            chargePointDetail?.chargeConnectors?.map(
                                              (item) => item.type
                                            ) ?? [];
                                          const tmpChargeConnectorList = [];
                                          for (let i = 0; i < iValue; i++) {
                                            if (cpConnectorList.length > i) {
                                              tmpChargeConnectorList.push(cpConnectorList[i]);
                                            } else {
                                              // Default new connector type should be CCS2
                                              tmpChargeConnectorList.push(
                                                ChargeConstants.ChargeConnectorType.CCS2
                                              );
                                            }
                                          }
                                          setChargeConnectorList(tmpChargeConnectorList);
                                        }}
                                        isDropdownForm={true}
                                        disabled={!Utils.isValid(selectedChargeModel)}
                                      />
                                    </div>
                                  </div>
                                  {/* thong tin voi sac */}
                                  {chargeConnectorList.map((connector, index) => (
                                    <div key={index} className="col-lg-4 mb-4 px-2">
                                      <div>
                                        {UIHelper.buildFormLabel(`Súng sạc ${index + 1}`, true)}
                                        <KTBSDropdown
                                          name={`connectorType${index}`}
                                          direction={KTBSDropdownDirections.up}
                                          toggleElement={
                                            <button
                                              className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!Utils.isValid(selectedChargeModel)
                                                ? 'disabled'
                                                : ''
                                                }`}
                                              type="button"
                                            >
                                              {ChargeHelper.Utils.getChargeConnectorTypeName(connector) ||
                                                connector}
                                            </button>
                                          }
                                          selectedValue={connector}
                                          dropdownMenuItems={
                                            ChargeHelper.Data.chargeConnectorTypeOptions
                                          }
                                          dropdownMenuClassName="overflow-auto w-100"
                                          dropdownMenuStyle={{ maxHeight: '30vh' }}
                                          onChange={(value) => {
                                            setChargeConnectorList(
                                              chargeConnectorList.map((item, i) =>
                                                i === index ? value : item
                                              )
                                            );
                                          }}
                                          isDropdownForm={true}
                                          disabled={!Utils.isValid(selectedChargeModel)}
                                        // disabled={
                                        //   editMode &&
                                        //   index < chargePointDetail?.chargeConnectors?.length
                                        // }
                                        />
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="pt-4">
                              {/* gia dien */}
                              <div
                                className="px-4 pb-4"
                                style={{
                                  borderBottom: `1px dashed ${AppColors.gray[300]}`,
                                }}
                              >
                                {/* <span
                                  style={UIHelper.buildFontStyle(
                                    '400',
                                    '14px',
                                    AppColors.gray[600]
                                  )}
                                >
                                  Tổng hóa đơn sẽ được cấu thành từ giá bán mỗi kWh điện sạc cho xe,
                                  cùng với phí dịch vụ đi kèm như phí giữ chỗ và phí quá giờ khi xe
                                  đã sạc đầy nhưng chủ xe chưa đến rút đầu sạc ra khỏi xe và đặt lại
                                  về trụ sạc.
                                </span> */}

                                <div className="mt-0">
                                  {UIHelper.buildFormLabel('Thiết lập giá sạc điện', true)}
                                  <div className="">
                                    <KTSwitch
                                      name="pricingOn"
                                      checked={pricingOn}
                                      onChange={(value) => {
                                        setPricingOn(value);
                                      }}
                                      type={KTSwitchType.outline}
                                      showIcon={true}
                                      text={
                                        pricingOn
                                          ? 'Giá trụ sạc sẽ được thiết lập riêng dựa theo thiết lập bên dưới'
                                          : 'Giá trụ sạc sẽ được lấy theo mặc định của trạm sạc'
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              <div
                                className="row m-0 p-0 px-2 mt-4"
                                style={{ borderBottom: `1px dashed ${AppColors.gray[300]}` }}
                              >
                                {/* don gia sac qua gio */}
                                <div className="col-lg-4 mb-4 px-2">
                                  <div>
                                    <div className='d-flex gap-2'>
                                      {UIHelper.buildFormLabel('Đơn giá sạc quá giờ ', pricingOn, false)}
                                      <KTTooltip
                                        text={`<div>Là số chi phí khách hàng phải trả cho mỗi phút chưa rút súng sạc ra khỏi xe và đặt lại về trụ sạc</div>`}
                                        textHeader="Đơn giá sạc quá giờ "
                                        isHtmlContent
                                      >
                                        <i
                                          className="fa-regular fa-info-circle"
                                          style={{ color: AppColors.info }}
                                        />
                                      </KTTooltip>
                                    </div>
                                    <Field name="overchargePrice">
                                      {({ field, form, meta }) => (
                                        <KTFormInput
                                          type={KTFormInputType.currency}
                                          unit="VNĐ/phút"
                                          placeholder="Nhập đơn giá sạc quá giờ"
                                          name={field.name}
                                          value={field.value}
                                          onChange={(value) => {
                                            form.setFieldValue(field.name, value);
                                          }}
                                          onBlur={() => {
                                            form.setFieldTouched(field.name, true);
                                          }}
                                          enableCheckValid={true}
                                          isValid={_.isEmpty(meta.error)}
                                          isTouched={meta.touched}
                                          feedbackText={meta.error}
                                          disabled={!pricingOn}
                                        />
                                      )}
                                    </Field>
                                  </div>
                                </div>

                                {/* thoi gian cho mien phi */}
                                <div className="col-lg-4 mb-4 px-2">
                                  <div>
                                    <div className='d-flex gap-2'>
                                      {UIHelper.buildFormLabel('Thời gian chờ miễn phí ', pricingOn, false)}
                                      <KTTooltip
                                        text={`<div>Thời gian chờ miễn phí là thời gian sau khi xe đã sạc đầy nhưng chủ xe chưa đến hoàn thành rút súng sạc ra khỏi xe và đặt lại về trụ sạc</div>`}
                                        textHeader="Thời gian chờ miễn phí "
                                        isHtmlContent
                                      >
                                        <i
                                          className="fa-regular fa-info-circle"
                                          style={{ color: AppColors.info }}
                                        />
                                      </KTTooltip>
                                    </div>
                                    <Field name="freeOverchargeDuration">
                                      {({ field, form, meta }) => (
                                        <KTFormInput
                                          type={KTFormInputType.currency}
                                          unit="phút"
                                          placeholder="Nhập thời gian chờ miễn phí"
                                          name={field.name}
                                          value={field.value}
                                          onChange={(value) => {
                                            form.setFieldValue(field.name, value);
                                          }}
                                          onBlur={() => {
                                            form.setFieldTouched(field.name, true);
                                          }}
                                          enableCheckValid={true}
                                          isValid={_.isEmpty(meta.error)}
                                          isTouched={meta.touched}
                                          feedbackText={meta.error}
                                          disabled={!pricingOn}
                                        />
                                      )}
                                    </Field>
                                  </div>
                                </div>
                                {/* gia dat giu cho */}
                                <div className="col-lg-4 mb-4 px-2">
                                  <div>
                                    <div className='d-flex gap-2'>
                                      {UIHelper.buildFormLabel('Giá đặt giữ chỗ', pricingOn, false)}
                                      <KTTooltip
                                        text={`<div>Giá đặt giữ chỗ là dịch vụ đặt chỗ trước tại trụ sạc, để tránh trụ sạc bị người khác sử dụng trước trong khi lái xe chưa kịp đưa xe đến.</div>`}
                                        textHeader="Giá đặt giữ chỗ"
                                        isHtmlContent
                                      >
                                        <i
                                          className="fa-regular fa-info-circle"
                                          style={{ color: AppColors.info }}
                                        />
                                      </KTTooltip>
                                    </div>
                                    <Field name="reservationFee">
                                      {({ field, form, meta }) => (
                                        <KTFormInput
                                          type={KTFormInputType.currency}
                                          unit="phút"
                                          placeholder="Nhập giá đặt giữ chỗ"
                                          name={field.name}
                                          value={field.value}
                                          onChange={(value) => {
                                            form.setFieldValue(field.name, value);
                                          }}
                                          onBlur={() => {
                                            form.setFieldTouched(field.name, true);
                                          }}
                                          enableCheckValid={true}
                                          isValid={_.isEmpty(meta.error)}
                                          isTouched={meta.touched}
                                          feedbackText={meta.error}
                                          disabled={!pricingOn}
                                        />
                                      )}
                                    </Field>
                                  </div>
                                </div>
                              </div>

                              {/* co che tinh gia dien */}
                              <div>
                                {UIHelper.buildCardHeader(
                                  'Cơ chế tính giá điện',
                                  false,
                                  null,
                                  true
                                )}
                                <div className="row m-0 p-0 px-2">
                                  {/* cach tinh gia dien */}
                                  <div className="col-lg-4 mb-4 px-2">
                                    <div>
                                      {UIHelper.buildFormLabel('Cách tính giá điện', pricingOn)}
                                      <Field name="pricingMode">
                                        {({ field, form, meta }) => (
                                          <KTBSDropdown
                                            name={field.name}
                                            toggleElement={
                                              <button
                                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!pricingOn ? 'disabled' : ''
                                                  }`}
                                                type="button"
                                              >
                                                {field.value
                                                  ? _.find(
                                                    ChargeHelper.Data.chargePointPricingModeOptions,
                                                    (item) => item?.value === field.value
                                                  )?.name
                                                  : 'Chọn cách tính giá điện'}
                                              </button>
                                            }
                                            selectedValue={field.value}
                                            dropdownMenuItems={
                                              ChargeHelper.Data.chargePointPricingModeOptions
                                            }
                                            dropdownMenuClassName="overflow-auto w-100"
                                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                            }}
                                            isDropdownForm={true}
                                            disabled={!pricingOn}
                                          />
                                        )}
                                      </Field>
                                    </div>
                                  </div>
                                  {/* don gia */}
                                  {formikProps.values.pricingMode ===
                                    ChargeConstants.ChargePricingMode.FLAT && (
                                      <div className="col-lg-4 mb-4 px-2">
                                        <div>
                                          {UIHelper.buildFormLabel('Giá sạc cố định', pricingOn)}
                                          <Field name="flatPrice">
                                            {({ field, form, meta }) => (
                                              <KTFormInput
                                                type={KTFormInputType.currency}
                                                unit="VNĐ/kWh"
                                                placeholder="Nhập giá sạc cố định"
                                                name={field.name}
                                                value={field.value}
                                                onChange={(value) => {
                                                  form.setFieldValue(field.name, value);
                                                }}
                                                onBlur={() => {
                                                  form.setFieldTouched(field.name, true);
                                                }}
                                                enableCheckValid={true}
                                                isValid={_.isEmpty(meta.error)}
                                                isTouched={meta.touched}
                                                feedbackText={meta.error}
                                                disabled={!pricingOn}
                                              />
                                            )}
                                          </Field>
                                        </div>
                                      </div>
                                    )}
                                  {formikProps.values.pricingMode ===
                                    ChargeConstants.ChargePricingMode.HOURS && (
                                      <>
                                        <div className="col-lg-4 mb-4 px-2">
                                          <div>
                                            {/* gia gio binh thuong */}
                                            <div>
                                              {UIHelper.buildFormLabel(
                                                'Giá giờ bình thường',
                                                pricingOn
                                              )}
                                              <Field name="normalPrice">
                                                {({ field, form, meta }) => (
                                                  <KTFormInput
                                                    type={KTFormInputType.currency}
                                                    unit="VNĐ/kWh"
                                                    placeholder="Nhập giá giờ bình thường"
                                                    name={field.name}
                                                    value={field.value}
                                                    onChange={(value) => {
                                                      form.setFieldValue(field.name, value);
                                                    }}
                                                    onBlur={() => {
                                                      form.setFieldTouched(field.name, true);
                                                    }}
                                                    enableCheckValid={true}
                                                    isValid={_.isEmpty(meta.error)}
                                                    isTouched={meta.touched}
                                                    feedbackText={meta.error}
                                                    disabled={!pricingOn}
                                                  />
                                                )}
                                              </Field>
                                            </div>
                                          </div>
                                        </div>
                                        {/* gia gio cao diem */}
                                        <div className="col-lg-4 mb-4 px-2">
                                          <div>
                                            {UIHelper.buildFormLabel('Giá giờ cao điểm', pricingOn)}
                                            <Field name="peakPrice">
                                              {({ field, form, meta }) => (
                                                <KTFormInput
                                                  type={KTFormInputType.currency}
                                                  unit="VNĐ/kWh"
                                                  placeholder="Nhập giá giờ cao điểm"
                                                  name={field.name}
                                                  value={field.value}
                                                  onChange={(value) => {
                                                    form.setFieldValue(field.name, value);
                                                  }}
                                                  onBlur={() => {
                                                    form.setFieldTouched(field.name, true);
                                                  }}
                                                  enableCheckValid={true}
                                                  isValid={_.isEmpty(meta.error)}
                                                  isTouched={meta.touched}
                                                  feedbackText={meta.error}
                                                  disabled={!pricingOn}
                                                />
                                              )}
                                            </Field>
                                          </div>
                                        </div>
                                        {/* gia gio thap diem */}
                                        <div className="col-lg-4 mb-4 px-2">
                                          <div>
                                            {UIHelper.buildFormLabel('Giá giờ thấp điểm', pricingOn)}
                                            <Field name="offPeakPrice">
                                              {({ field, form, meta }) => (
                                                <KTFormInput
                                                  type={KTFormInputType.currency}
                                                  unit="VNĐ/kWh"
                                                  placeholder="Nhập giá giờ thấp điểm"
                                                  name={field.name}
                                                  value={field.value}
                                                  onChange={(value) => {
                                                    form.setFieldValue(field.name, value);
                                                  }}
                                                  onBlur={() => {
                                                    form.setFieldTouched(field.name, true);
                                                  }}
                                                  enableCheckValid={true}
                                                  isValid={_.isEmpty(meta.error)}
                                                  isTouched={meta.touched}
                                                  feedbackText={meta.error}
                                                  disabled={!pricingOn}
                                                />
                                              )}
                                            </Field>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>,
                      false,
                      false,
                      true,
                      false,
                      AppColors.gray[300],
                      true
                    )}
                  </motion.div>
                </AnimatePresence>
              </div>

              {/* footer */}
              <div
                ref={refFooter}
                className="bg-white d-flex align-items-center justify-content-end p-4 gap-3"
                style={{
                  position: 'fixed',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  zIndex: 100,
                }}
              >
                {UIHelper.buildNegativeButton('Hủy bỏ', () => {
                  router.navigate(-1);
                })}
                {UIHelper.buildGreenButton(
                  'Lưu lại',
                  () => {
                    if (!_.isEmpty(refFormik.current?.errors)) {
                      const firstErrorKey = Object.keys(refFormik.current?.errors)[0];
                      if (firstErrorKey) {
                        ToastHelper.showError(refFormik.current?.errors[firstErrorKey]);
                      }
                      if (
                        Utils.isValid(refFormik.current?.errors?.freeOverchargeDuration) ||
                        Utils.isValid(refFormik.current?.errors?.overchargePrice) ||
                        Utils.isValid(refFormik.current?.errors?.reservationFee) ||
                        Utils.isValid(refFormik.current?.errors?.pricingMode) ||
                        Utils.isValid(refFormik.current?.errors?.flatPrice) ||
                        Utils.isValid(refFormik.current?.errors?.normalPrice) ||
                        Utils.isValid(refFormik.current?.errors?.peakPrice) ||
                        Utils.isValid(refFormik.current?.errors?.offPeakPrice)
                      ) {
                        setSelectedTab(tabs[0]);
                      }
                      return;
                    }
                    setReadyToValidate(true);
                    refFormik?.current?.handleSubmit();
                  },
                  null,
                  false,
                  loading
                )}
              </div>
            </div>
          );
        }}
      </Formik>
    </div>
  );
}

export default ChargePointAddView;
